 <!-- facebook login -->
<ion-button *ngIf="!(loading$ | async)" class="fb-btn btn--large" mode="md" (click)="socialSignIn('facebook')" expand="full">
   <ion-icon class="facebook"></ion-icon>
   <span class="facebook-text">{{ 'SOCIAL_LOGIN.FACEBOOK_LOGIN' | translate }}</span>
</ion-button>

<ion-button *ngIf="loading$ | async" class="fb-btn btn--large" mode="md"  disabled="true" expand="full">
   <ion-icon class="facebook"></ion-icon>
   <ion-spinner name="crescent"></ion-spinner>
</ion-button>


<p class="ion-text-center facebook-disclaimer">{{ 'SOCIAL_LOGIN.FACEBOOK_NO_WORRIES' | translate }}</p>

<!--<p>
  <button (click)="socialSignIn('facebook')" class="btn btn-glam10 btn-secondary btn-block" tabindex="1"> <fa name="facebook"></fa>&nbsp; Facebook prijava </button>
</p>-->